import { NavigationService } from "app/core/services/navigation/navigation.service";
import { AccountService } from "app/core/services/api/account-management/individual/account.service";

import { inject } from "@angular/core";
import { catchError, forkJoin, of, timeout } from "rxjs";

/**
 * Dữ liệu phải có TRƯỚC khi vào bất kỳ màn hình nào của vỏ ứng dụng đã đăng nhập.
 *
 * SL-771 — thêm getAccountLogin() vào đây. Đó là nơi DUY NHẤT ghi claim phạm vi dữ liệu
 * (AllowedDataScopes / HomeOrganizationUnitId) vào storage, nhưng trước đây nó chỉ là resolver của
 * vài route rời rạc (Ví, Tài khoản, Hồ sơ, Chính sách hoa hồng, Địa chỉ kho, Điều chỉnh lô hàng, Công
 * nợ). Màn Nhóm tài khoản không nằm trong số đó, nên claim có hay không tuỳ vào việc người dùng đã
 * tình cờ ghé qua một trong các trang kia hay chưa — mà getter allowedDataScopes lại lùi về [1] khi
 * chưa có. Kết quả: dropdown "Đơn vị phụ trách" mất mục "Trụ sở chính" lúc có lúc không, phụ thuộc
 * đường đi trước đó. Nạp một lần ở vỏ ứng dụng thì mọi màn hình đều có cùng một sự thật.
 *
 * Hai lời gọi độc lập nhau nên chạy song song. Lỗi/chậm ở phần tài khoản KHÔNG được chặn điều hướng:
 * timeout + nuốt lỗi, còn các màn hình quan tâm tới claim thì theo dõi qua AppStorageService.
 */
export const initialDataResolver = () => {
    const navigationService = inject(NavigationService);
    const accountService = inject(AccountService);

    return forkJoin({
        navigation: navigationService.get(),
        account: accountService.getAccountLogin().pipe(
            timeout(10000),
            catchError(() => of(null)),
        ),
    });
};
